import React from "react";
import { useTranslation } from "react-i18next";

import { StyledSelect } from "../../organisms/Menus/FilterMenu/FilterMenuStyles";
import { IColumnProps } from "../../../interfaces/tables";
import { OrganizationCategoryOpts } from "../../../constants/organizationCategories";

interface Props {
  column: IColumnProps<{}>;
}

const OrgCategoryFilter: React.FC<Props> = ({ column }) => {
  const { t } = useTranslation();
  return (
    <StyledSelect
      placeholder={t("Filter.Category")}
      fluid
      search
      selection
      multiple
      options={OrganizationCategoryOpts}
      onChange={(e: any, data: any) => column.setFilter(data.value)}
    />
  );
};

export default OrgCategoryFilter;
